<template>
<div v-if="par" style="display:flex;flex-direction:row" v-loading="loading" :element-loading-text="loadingText">
  <!-- <div :style="popupStyle" class="hover-popup">
    <div style="background-color:#46C8C8;color:white;font-weight:500;padding:5px 10px">
      {{ hoveredFragment.name }}
    </div>

    <div style="background-color:white;border-top:none;padding:5px 10px">
        <img :src="smilesLink(hoveredFragment.smi)" height="150px" width="150px">
    </div>
  </div> -->

  <!-- <div class="shaded-box padded-box">
    <div style="font-size:20px;text-align:center">Fragment Frequencies</div>

    Sort by <select id="fragment-order" @change="sort">
      <option value="frequency">Frequency</option>
      <option value="atoms"># Atoms</option>
    </select>
  </div> -->

  <div v-if="!par.fragmentation">
    You have chosen not to fragment the compounds.
    Please check the 'fragmentation' option when submitting the job if you would like to see the fragmentation results.
    By default, DRIFT will not fragment compounds because it's time comsuming.
  </div>

  <div v-if="par.fragmentation" style="flex:1 1">

    <div class="shaded-box">
      <div style="padding:10px;font-size:20px"><b>Fragments Sorted By Frequency</b></div>
      <div><canvas id="fragments-chart"></canvas></div>
    </div>

    <div v-for="id in sortedFragmentIds" :key="id" class="shaded-box padded-box" style="display:flex;flex-direction:row;font-size:12px">
      <div style="flex-grow:1">
        
        <div style="font-size: 20px;margin:10px 0px">
          <span><b>Fragment {{id + 1}}</b></span>
        </div>

        <div style="display:flex;flex-direction:row">
          <div style="flex: 1 1;margin-right:20px">
            <div style="margin-bottom:10px;display:flex;flex-direction:row;align-items:center">
              <div style="margin:5px 5px 5px 0px"><b>Frequency: </b></div>
              <div style="width:180px"><el-progress :stroke-width="6" :color="'#46c8c8'" :percentage="parseFloat(toFixed(fragments[id].freq * 100, 2))"></el-progress></div>
            </div>

            <div style="margin-bottom:10px">
              <div style="margin:5px 0px"><b>SMILES</b></div>
              <div style="margin-left:10px"><textarea :value="fragments[id].smi" disabled style="resize:none;background-color:white;outline:none;border:none"></textarea></div>
            </div>

            <div>
              <div><b>Secondary Structure</b></div>
              <div><img :src="smilesLink(fragments[id].smi)" width="150px"></div>
            </div>
          </div>

          <div style="flex: 1 1">
            <div style="margin-bottom: 5px">
              <b>Source Compound</b>
            </div>
            <div style="margin-left:10px">
              <select v-model="selectedSource[id]">
                <option v-for="(source, iSource) in fragments[id].source" :value="source" :key="iSource">{{source}}</option>
              </select>
            </div>
            <div><img :src="smilesLink(compounds[selectedSource[id]].smiles)" width="150px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div  v-if="par.fragmentation" style="flex:0 0 300px;margin-left:15px;margin-top:20px;">
    <div style="position:sticky;top:10px">
      <!-- <div class="results-menu-filters" @click="filtersVisible=true"><i class="el-icon-edit-outline"></i> Filters</div> -->

      <!-- Number of results -->
      <div style="margin-bottom:20px"><b v-text="fragments.length"></b> Fragments</div>

      <div class="results-menu-sort">
        <!-- <div @click="sortOptions=getCurrentRef().getSortTokens();sortMenuVisible=true"><i class="el-icon-sort"></i> Sort</div> -->
        <div @click="sortMenuVisible=true"><i class="el-icon-sort"></i> Sort</div>

        <!-- Sort Menu -->
        <div class="popup-menu" v-if="sortMenuVisible">
          <div class="popup-menu-head">
            <div class="popup-menu-title">CHOOSE SORT OPTIONS</div>
            <div class="popup-menu-close" @click="sortMenuVisible=false"><i class="el-icon-close"></i></div>
          </div>
          <div class="popup-menu-body">
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortFragments('id')">
              <span>ID</span>
            </div>
            <div class="popup-menu-item" @click="sortMenuVisible=false;sortFragments('frequency')">
              <span>Frequency</span>
            </div>
          </div>
        </div>
      </div>

      <div class="results-menu-download">
        <div class="popup-menu-button" @click="downloadMenuVisible=true"><i class="el-icon-download"></i> Download</div>

        <!-- Download Menu -->
        <div class="popup-menu" v-if="downloadMenuVisible">
          <div class="popup-menu-head">
            <div class="popup-menu-title">DOWNLOAD</div>
            <div class="popup-menu-close" @click="downloadMenuVisible=false"><i class="el-icon-close"></i></div>
          </div>
          <div class="popup-menu-body">
            <!-- <div class="popup-menu-item" @click="savePdf();downloadMenuVisible=false;">
              Report (pdf)
            </div> -->
            <div class="popup-menu-item" @click="savePng();downloadMenuVisible=false">
              Fragments Frequency Plot (png)
            </div>
            <div class="popup-menu-item" @click="saveFragments();downloadMenuVisible=false">
              Fragments for Current Query Compound (csv)
            </div>
            <div class="popup-menu-item" @click="saveAllFragments();downloadMenuVisible=false">
              Fragments for All Query Compounds (csv)
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
// import Chart from 'chart.js'
import { bus } from '../bus.js'
import axios from 'axios'
import * as d3 from 'd3'
import utils from '../utils.js'
import Vuex from 'vuex'
import makeTaskStore from '../store/task-store.js'
import Chart from 'chart.js'
import interpolate from 'color-interpolate'
import C2S from 'canvas2svg'

export default {
  name: 'Fragments',

  data () {
    return {
      task: '',
      selectedSource: [],
      hoveredFragment: {
        name: '',
        smi: ''
      },
      popupStyle: {
        display: 'none',
        top: 0,
        left: 0
      },

      sortMenuVisible: false,
      downloadMenuVisible: false,
      sortDirection: 1,
      sortBy: 'frequency',

      loading: false,
      loadingText: ''
    }
  },

  components: {
  },

  computed: {
    ...Vuex.mapGetters([
      'par', 'fragments', 'compounds'
    ]),

    sortedFragmentIds () {
      let ids = this.fragments.map((fragment, id) => id)
      if (this.sortBy === 'id') {
        ids.sort((a, b) => (b - a) * this.sortDirection)
      } else if (this.sortBy === 'frequency') {
        ids.sort((a, b) => (this.fragments[b].freq - this.fragments[a].freq) * this.sortDirection)
      }

      return ids
    },

    fragmentFrequencyStyle () {
      let v = this
      return {
        width: `${v.svgWidth}px`,
        height: '500px'
      }
    },

    svgWidth () {
      let l = this.fragments.length
      return (l < 100 ? 1000 : l * 10)
    },

    ncompounds () {
      let smi = this.$store.getters.par.compound
      if (smi) {
        return smi.split('\n').filter(line => line.trim() !== '').length
      } else {
        return 0
      }
    }
  },

  watch: {
    fragments: {
      immediate: true,
      handler (newFragments, oldFragments) {
        let v = this
        if (newFragments.length > 0) {
          v.selectedSource = v.fragments.map(f => { return f.source[0] })
          v.$nextTick(() => {
            let ids = v.fragments.map((f, id) => id)
            ids.sort((a, b) => this.fragments[b].freq - this.fragments[a].freq)
            let labels = ids.slice(0, 30).map(id => `Fragment ${id + 1}`)
            let data = ids.slice(0, 30).map(id => v.fragments[id].freq)
            v.setChart('fragmentsChart', document.getElementById('fragments-chart'), labels, data)
          })
        }
      }
    }
  },

  methods: {
    ...utils.mapUtils([
      'targetLink',
      'smilesLink',
      'toFixed',
      'download'
    ]),

    sortFragments (by) {
      this.sortBy = by
      this.sortDirection *= -1
    },

    sort (event) {
      let token = event.target.value

      console.log('sort by ' + token)

      let actions = {
        frequency: (d1, d2) => {
          return d2.value - d1.value
        },

        atoms: (d1, d2) => {
          return d2.smi.length - d1.smi.length
        }
      }

      this.chart.update(actions[token])
    },

    setChart (chartname, element, labels, data) {
      let v = this
      let n = labels.length
      if (n > 0) {
        element.parentElement.style.width = `100%`
        element.parentElement.style.height = `${labels.length * 15 + 30}px`
        let colormap = interpolate(['#053795', 'green', 'yellow', '#900c3f'])
        let mx = Math.max(...data)
        let mn = Math.min(...data)
        let d = mx - mn
        let colors = data.map(i => colormap(d === 0 ? 0.5 : (i - mn) / (mx - mn)))
        if (chartname in v) {
          let chart = v[chartname]
          chart.data.labels.length = 0
          labels.forEach(label => { chart.data.labels.push(label) })
          chart.data.datasets.forEach(dataset => { dataset.data = data })
          chart.update()
        } else {
          v[chartname] = new Chart(element, {
            type: 'horizontalBar',
            data: {
              datasets: [{
                data: data,
                backgroundColor: colors
              }],
              labels: labels
            },
            options: {
              maintainAspectRatio: false,
              responsive: true,
              legend: {
                display: false
              }
            }
          })
        }
      }
    },

    count () {
      return 0
    },

    getTargetsFunctions (targets) {
      let functions = []
      for (let target of targets) {
        for (let func of target.functions) {
          let i = functions.findIndex((f) => {
            return f.id === func.id
          })
          if (i === -1) {
            functions.push({func: func, num: 0})
          } else {
            functions[i].num += 1
          }
        }
      }
      return functions
    },

    getTargetsFunctionsByName (targets, n) {
      let functionsHub = []
      for (let target of targets) {
        for (let func of target.functions) {
          let i = functionsHub.findIndex((functions) => {
            return functions.name === func.name
          })
          if (i === -1) {
            functionsHub.push({functions: [func], name: func.name})
          } else {
            functionsHub[i].functions.push(func)
          }
        }
      }
      functionsHub.sort((a, b) => b.functions.length - a.functions.length)
      return functionsHub
    },

    fragmentLines (store, icompound) {
      let content = ''
      for (let fragmentid in store.getters.fragments) {
        let fragment = store.getters.fragments[fragmentid]
        content += `${parseInt(icompound) + 1},${fragmentid},${fragment.smi},${fragment.freq},${fragment.source.join(' ')}\n`
      }
      return content
    },

    saveFragments () {
      let content = 'Query Compound,Fragment No.,Fragment SMILES,Frequency,Source\n'
      content += this.fragmentLines(this.$store, this.$store.state.route.params.icompound)
      this.download(content, `Drift-${this.$store.state.route.params.id}-${this.$store.state.route.params.icompound + 1}-fragments.csv`)
    },

    async saveAllFragments () {
      this.loading = true
      let store = new Vuex.Store(makeTaskStore())
      let r = {}
      for (let k of ['minimalCompoundSimilarity', 'hideNullCompounds', 'hideOwnTargets', 'targetTypes', 'targetSpecies', 'assayRange']) {
        r[k] = this.$store.state[k]
      }
      store.commit('set', r)

      let taskid = this.$store.state.route.params.id
      let content = 'Query Compound,Fragment No.,Fragment SMILES,Frequency,Source\n'
      for (let icompound = 0; icompound < this.ncompounds; icompound++) {
        this.loadingText = `Downloading Fragments for Query Compound ${icompound + 1}`
        await store.dispatch('fetchTask', {taskid, icompound})
        content += this.fragmentLines(store, icompound)
      }
      this.download(content, `Drift-${this.$store.state.route.params.id}-fragments.csv`)
      this.loading = false
    },

    savePng () {
      var link = document.createElement('a')
      link.download = 'fragments.png'
      link.href = document.getElementById('fragments-chart').toDataURL()
      link.click()
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.summary-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;
}

.summary-row-label {
  color: #85929e;
  font-weight: bold;
  font-size: 30px;
  width: 200px;
  min-width: 200px;
}

.summary-row-canvas {
  margin: 0px;
}

.summary-row-canvas canvas {
  width: 700px !important;
  height: 350px !important;
}

.fragment-row {
  /*
  border: 1px solid lighten($font-grey, 50%);
  */
  border-radius: 4px;
  margin: 20px 0px;
}

.fragment-card-head {
  /*
  border-bottom: 1px solid lighten($font-grey, 50%);
  */
  height: 30px;
  line-height: 30px;
  padding: 5px 5px 5px 20px;
  font-weight: 600;
}

.fragment-card-body {
  padding: 20px;
}

.hover-popup {
  position: fixed;
  width: 160px;
  z-index: 99;
  /*
  border-radius: 4px;
  */
  border: 1px solid #46C8C8;
  font-size: 12px;
}

</style>
